<template>
  <!-- 用户登录页 - 账号密码登录 -->
  <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>

    <div class="user-err">
      <zt-tip :msg="userErr" type="error"></zt-tip>
    </div>

    <el-form-item prop="telephone">
      <el-input placeholder="请输入手机号码" v-model.trim="form.telephone" clearable>
        <svg-icon icon="telephone" slot="prefix" size="24px"/>
      </el-input>
    </el-form-item>

    <el-form-item prop="password" :error="passwordErr">
      <el-input placeholder="请输入密码" type="password" v-model="form.password" clearable>
        <svg-icon icon="password" slot="prefix" size="24px"/>
      </el-input>
    </el-form-item>

    <el-form-item prop="captcha_code" :error="imageCodeErr" v-if="needCaptchaCode">
      <div class="code-input">
        <el-input placeholder="请输入验证码" v-model="form.captcha_code"/>
        <ImgCaptcha class="code" 
          :loading.sync="loadingCaptcha"
          :src="imageCodeURL" 
          alt="验证码"
          @click.native="onRefreshImgCode"></ImgCaptcha>
      </div>
    </el-form-item>

    <el-form-item class="mb0">
      <el-checkbox v-model="remeberMe">记住我</el-checkbox>
      <router-link class="forget-link" to="/forget">忘记密码</router-link>
    </el-form-item>

    <zt-button type="primary" :loading="loading" :disabled="loadingCaptcha" @click.enter.exact="onSubmit" native-type="submit">登录</zt-button>
    <router-link class="register-link" to="/register">暂无账号? 立即注册></router-link>
  </el-form>
</template>

<script>

import ZtTip from '@/components/ZtTip'
import ImgCaptcha from '@/components/ImgCaptcha'
import createUniqueString from '@/utils/createUniqueString'
import loginMixin from '../mixins/login'
import { captcha } from '@/api/login'

export default {
  name: 'PhoneLogin',
  components: { ZtTip, ImgCaptcha },
  mixins: [ loginMixin ],


  data: () => ({

    form: {
      telephone: process.env.VUE_APP_DEV_PHONE || '', // 开发环境下自动填充测试用的账号密码
      password: process.env.VUE_APP_DEV_PWD || '', 
      captcha_code: process.env.VUE_APP_DEV_CODE || '', // 图形验证码
    },
    rules: {
      telephone: [ { required: true, message: '请输入手机号码' } ],
      password: [ { required: true, message: '请输入密码' } ],
      captcha_code: [ { required: true, message: '请输入验证码', trigger: 'blur' } ]
    },
    passwordErr: '',
    imageCodeErr: '',
    captcha_r: createUniqueString(),  // 图形验证码的r
    captcha_t: Date.now(),   // 图形验证码的时间戳（避免304缓存）
    loadingCaptcha: false, // loading图形验证码
  }),

  computed: {
    imageCodeURL() {
      return captcha(this.captcha_r, this.captcha_t)
    },
  },

  watch: {
    'form.telephone'(val) {
      if (this.userErr) this.userErr = ''
      if (val.indexOf(" ") !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, "");
      }
    },
    'form.password'() {
      if (this.userErr) this.userErr = ''
    },
    '$route.query.telephone': {
      immediate: true,
      handler(v) {
        if (v) {
          this.form.telephone = v
          this.form.password = ''
          this.captcha_code = ''
        }
      }
    },
  },
  methods: {

    // 提交表单
    onSubmit() {
      const { form } = this.$refs
      form.validate((valid) => {
        if (!valid) return
        const reqData = { ...this.form, captcha_r: this.captcha_r }
        if( this.needCaptchaCode === false ) {
          reqData.captcha_code = ''
        }
        this.login(reqData)
      })
    },

    // 刷新验证码
    onRefreshImgCode() {
      if(this.loadingCaptcha) return 
      this.captcha_r = createUniqueString()
    }
  },

}
</script>

<style lang="scss" scoped>
@import "~@/styles/login.scss";
</style>